(function() {
    'use strict';
    angular
        .module('getwellApp')
        .factory('Practitioner', Practitioner);

    Practitioner.$inject = ['$resource'];

    function Practitioner ($resource) {
        var resourceUrl =  'api/practitioners/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
